import { useEffect } from 'react';
import { throttle } from 'underscore';
import { shouldLoadMore } from './helpers/infinite_scroll_helper';

export default (useInfiniteScroll, onEndOfElement, listRef, totalItems) => {
  if (!useInfiniteScroll) return;

  useEffect(() => {
    const checkFn = () => {
      if (listRef?.current?.childElementCount < totalItems && shouldLoadMore(listRef.current)) {
        onEndOfElement();
      }
    };

    checkFn();
    const onElementScroll = throttle(checkFn, 300);

    window.addEventListener('scroll', onElementScroll);

    return () => {
      window.removeEventListener('scroll', onElementScroll);
    };
  }, []);
};
